export class NoteImportModel {
    counter: number = 0;
    companyId: number = 0;
    branchId: number = 0;
    enterpriseId: number = 0;
    bussinessDocumentsTypeCode: number = 0;
    noteTypeId: number = 0;
    consecutive: number = 0;
    dateNote: Date = new Date();
    conceptCode: number = 0;
    operationTypeDianCode: number = 0;
    invoiceConsecutive: number = 0;
    invoiceBussinessDocumentsTypeCode: number = 0;
    cude: string = "";
    subtotalValue: number = 0;
    ivaValue: number = 0;
    totalValue: number = 0;
    valueToPay: number = 0;
    reteIvaValue: number = 0;
    reteFuenteValue: number = 0;
    reteIcaValue: number = 0;
    conceptInvoicingCode: number = 0;
    storeCode: number = 0;
    value: number = 0;
    articleCode: number = 0;
    quantity: number = 0;
    conceptIvaValue: number = 0;
    conceptReteFuenteValue: number = 0;
    conceptReteIcaValue: number = 0;

    constructor(
        counter: number,
        companyId: number,
        branchId: number,
        enterpriseId: number,
        bussinessDocumentsTypeCode: number,
        noteTypeId: number,
        consecutive: number,
        dateNote: Date,
        conceptCode: number,
        operationTypeDianCode: number,
        invoiceConsecutive: number,
        invoiceBussinessDocumentsTypeCode: number,
        cude: string,
        subtotalValue: number,
        ivaValue: number,
        totalValue: number,
        valueToPay: number,
        reteIvaValue: number,
        reteFuenteValue: number,
        reteIcaValue: number,
        conceptInvoicingCode: number,
        storeCode: number,
        value: number,
        articleCode: number,
        quantity: number,
        conceptIvaValue: number,
        conceptReteFuenteValue: number,
        conceptReteIcaValue: number
    ) {
        this.counter = counter;
        this.companyId = companyId;
        this.branchId = branchId;
        this.enterpriseId = enterpriseId;
        this.bussinessDocumentsTypeCode = bussinessDocumentsTypeCode;
        this.noteTypeId = noteTypeId;
        this.consecutive = consecutive;
        this.dateNote = dateNote;
        this.conceptCode = conceptCode;
        this.operationTypeDianCode = operationTypeDianCode;
        this.invoiceConsecutive = invoiceConsecutive;
        this.invoiceBussinessDocumentsTypeCode = invoiceBussinessDocumentsTypeCode;
        this.cude = cude;
        this.subtotalValue = subtotalValue;
        this.ivaValue = ivaValue;
        this.totalValue = totalValue;
        this.valueToPay = valueToPay;
        this.reteIvaValue = reteIvaValue;
        this.reteFuenteValue = reteFuenteValue;
        this.reteIcaValue = reteIcaValue;
        this.conceptInvoicingCode = conceptInvoicingCode;
        this.storeCode = storeCode;
        this.value = value;
        this.articleCode = articleCode;
        this.quantity = quantity;
        this.conceptIvaValue = conceptIvaValue;
        this.conceptReteFuenteValue = conceptReteFuenteValue;
        this.conceptReteIcaValue = conceptReteIcaValue;
    }
}
